import React, { useState, useEffect, useContext } from 'react';
// import { Helmet } from 'react-helmet';
const ThemeContext = React.createContext('fleet');
const useTheme = () => {
    const theme = useContext(ThemeContext);
    return theme;
};
const ThemeProvider = (props) => {
    const { theme, children } = props;
    const [brandTheme, setBrandTheme] = useState(theme);
    useEffect(() => {
        setBrandTheme(theme);
    }, []);
    return React.createElement(ThemeContext.Provider, { value: brandTheme }, children);
};
export { ThemeContext, ThemeProvider, useTheme };
//# sourceMappingURL=ThemeProvider.js.map